.footerActionsSeparator {
	text-align: center;
	display: inline-block;
	width: 16px;
}
